import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $ModalContent = styled('div')`
  margin-top: ${spacing('xl')};
  margin-right: auto;
  margin-left: auto;
`;
